<template>
  <div class="page-wrapper light">
    <section class="carousel">
      <Carousel        
        :carousel-items="banner"
        :loop="carouselLoop"
        :dots="carouselDots"
        :arrow="banner.length > 1 ? 'always' : 'never'"
        
      />
    </section>
    <section class="insurance-guide mb-m container">
      <Row 
        :gutter="16"
        type="flex"
        justify="center"
        class="code-row-bg"
      >
        <Col
          v-for="(card, index) in cards"
          :key="index"
          :xs="12"
          :sm="12"
          :md="6"
          :lg="6"
        >
          <IndexGuideCard v-bind="{card}" />          
        </Col>      
      </Row>
    </section>  
    <section class="container mb-l">
      <h2 class="section-title text-center mb-m">活動專區</h2>
      <ActivityCarousel
        :autoplay="carouselAutoPlay" 
        :autoplayspeed="carouselAutoPlaySpeed"
        :carousel-items="activityItems"
        :loop="carouselLoop"
        :dots="carouselDots"
        :arrow="activityItems.length > 1 ? 'always' : 'never'"
      />
    </section>
     <!-- <AdvertisementModal />   -->
    <QueryTabs 
      v-bind="{handleQuery, queryModelObj}"
      :loading="queryLoading"
    />   
    <IndexSteps />
    <Footerbar />
  </div>  
</template>

<script>
  import { Row, Col } from 'iview';
  import Carousel from '@/components/banner/Carousel';
  import ActivityCarousel from '@/components/banner/ActivityCarousel';
  import IndexGuideCard from '@/components/cards/IndexGuideCard';
  import QueryTabs from '@/components/tabs/QueryTabs';
  import IndexSteps from '@/components/steps/IndexSteps';
  import Footerbar from '@/components/layout/Footerbar'; 
  import cards from '@/staticData/index';
  //import AdvertisementModal from '@/components/modals/AdvertisementModal';
  import { FETCH_INSU_ACTION } from '@/store/modules/insurance/constants';
  import { GET_INDEX_BANNER_ACTION } from '@/store/modules/dynamicResource/constants';
  export default {
    components: {
      IndexGuideCard,
      Row,
      Col,
      Carousel,
      ActivityCarousel,
      QueryTabs,
      IndexSteps,
      Footerbar,
      //AdvertisementModal
    },
    data() {
      return {
        carouselAutoPlaySpeed:5000, //毫秒
        carouselAutoPlay:true,
        carouselLoop: true,
        carouselDots: 'none',
        carouselItems: [
             {
            // title: 'BANNER 0',
            //subTitle: '填問卷送寵物隨身包',           
            img: require('@/assets/activity/petbanners.jpg'),
            URL:'https://ec.rockgp.com/activity/petActivity'
          },
           {
            // title: 'BANNER 0',
            //subTitle: '疫苗險防疫險',           
            img: require('@/assets/banners-vaccine.jpg'),
            URL:'https://ec.rockgp.com/insurance/vaccine'
          },
           {
              title: '車險預約系統',
              subTitle: '保險不過期 保費更優惠',           
            // img: '/static/12117869656170.PNG',
              img: require('@/assets/14340598539592.jpg'),
              URL:'https://ec.rockgp.com/activity/reserveCarInsu'
           },
          {
              // title: 'BANNER 2',
              //subTitle: '汽車險',
              img: '/static/12117870124504.PNG',//img: require('@/assets/banner-index-1.jpg')
              URL:'https://ec.rockgp.com/insurance/car'            
          },  
          {
              // title: 'BANNER 3',
              //subTitle:'寵物險',
              img: require('@/assets/14340395948169.jpg'),
              URL:'https://ec.rockgp.com/insurance/pet'
          },          
          {
              // title: 'BANNER 4',
              subTitle: '',           
              img: require('@/assets/banner-index-1.jpg'),
              URL:''
          }
        ],       
        activityItems: [
          {
            img: require('@/assets/activity/10942678972571.jpg'),
            pathName: 'activiyReserveCarInsu'
          },
          {
            img: require('@/assets/activity/pet3.png'),
            pathName: 'activityReservePetInsu'
          }
        ],
        cards
      };
    },
    computed: {
      queryLoading() {
        return this.$store.state.insurance.loading;
      },
      queryModelObj() {       
        return this.$store.getters.initialQueryModel;
      },
      banner()
      {        
       return this.$store.state.dynamicResource.indexBanner;
      }

    },
    mounted()
    {
    this.$store.dispatch(GET_INDEX_BANNER_ACTION);
    },
    methods: {
      handleQuery(payload) {
        this.$store.dispatch(FETCH_INSU_ACTION, payload);
      }
    }
  };
</script>